// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* core-select-modal-page 
*/
:host core-scroll {
  padding: 0 var(--core-tablet-page-padding) 0px var(--core-padding-thin) !important;
  margin: 0 0 0 var(--core-padding-medium) !important;
  flex: 1;
  color: var(--core-colors-dvTeal);
}`, "",{"version":3,"sources":["webpack://./src/core-modules/components/core-list-modal/core-list-modal.modal-page.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKI;EACI,kFAAA;EACA,mDAAA;EACA,OAAA;EACA,gCAAA;AADR","sourcesContent":["/**\r\n* core-select-modal-page \r\n*/\r\n@import \"/src/theme/custom-variables.scss\";\r\n:host {\r\n    core-scroll {\r\n        padding: 0 var(--core-tablet-page-padding) 0px var(--core-padding-thin) !important;\r\n        margin: 0 0 0 var(--core-padding-medium) !important;\r\n        flex: 1;\r\n        color: var(--core-colors-dvTeal);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
